import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { customer } from "../characters/Customer";
import { empty } from "../characters/empty";
import { lena } from "../characters/Lena";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { images } from "./images";
import { RoomAfterRecapBTNS } from "./V3";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const VanessaCoffee1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingVanessa);
    empty.think(`Calling Vanessa...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    vanessa.talk(`Hey, ${mc.name}.`);
    mc.talk(`Hey, Vanessa what's up?`);
    vanessa.talk(`Is it important? I'm running late for work.`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {

        mc.talk(`Yes, it is.`);
    } else {

        mc.talk(`No, not really. I was wondering what you are up to today?`);
    }

    mc.talk(`But since you are busy, we'll talk some other time.`);
    vanessa.talk(`Don't be silly.\nDo you know the coffee shop at the corner of Martin St and George St?`);
    mc.talk(`Yes, I do.`);
    vanessa.talk(`Great!`);
    vanessa.talk(`Meet me there, I'll be there in a few minutes.`);

    return jump(VanessaCoffee2, "VanessaCoffee2");
};
export const VanessaCoffee2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1);

    mc.talk(`Vanessa is already here.`);
    ImageClass.setImage(images.v3.VanessaCoffee2);
    lena.talk(`Fuck sakes! You are late. Again!`);
    vanessa.talk(`Jeez... I said I'm sorry.`);
    lena.talk(`Sure, you always are.\nDammit, now I'm going to be late for my meeting. And it's your fault!`);
    vanessa.talk(`Meeting? What meeting?`);
    lena.talk(`None of your business!\nByeeeeeee!`);
    ImageClass.setImage(images.v3.VanessaCoffee3);
    lena.talk(`Oh shit, hey! Can I get you anything?`);
    vanessa.talk(`No, he is my friend. He came to see me.`);
    mc.talk(`Is wearing pink a dress code around here?`);
    lena.talk(`Right... I don't have time for this!`);
    lena.talk(`Have funnnn... Byeeeeee!`);
    ImageClass.setImage(images.v3.VanessaCoffee1_9);

    mc.talk(`What was that all about?`);
    vanessa.talk(`That's just Lena.`);
    mc.talk(`Is she your boss?`);
    vanessa.talk(`No. But she does a lot around here.`);
    vanessa.talk(`So, what's up?`);
    return jump(VanessaCoffee3, "VanessaCoffee3");
};
export const VanessaCoffee3 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_9);
    mc.think(`I need to think carefully what I want from her.`);
    mc.think(`I could ask her to help me with Ann.`);

    if (Question.globalAnswers.v2AgreeToSeeBJPic) {
        mc.think(`But I also came here to confront her about Chris.`);
        mc.think(`Or I can just keep my mouth shut for a bit longer about that.`);
    }

    mc.talk(`I wanted to talk to you about the other day at the bar.`);
    if (Question.globalAnswers.v1JoePresentIdea === "videogame") {

        vanessa.talk(`When you helped me with Joe's gift?`);
        vanessa.talk(`Well, I should say. TRIED to help.`);
        vanessa.talk(`Getting him a video game was a stupid idea.`);
        vanessa.talk(`But at least you tried.`);
    } else if (Question.globalAnswers.v1JoePresentIdea === "sextape") {

        vanessa.talk(`When you helped me with Joe's gift?`);
        vanessa.talk(`I must say, your suggestion is amazing!`);
        vanessa.talk(`I couldn't have thought about that myself!`);
        vanessa.talk(`I made the right decision by calling you!`);
    } else {

        vanessa.talk(`When you couldn't help me with Joe's gift?`);
        vanessa.talk(`I thought you might know what your best friend might want.\nI was wrong.`);
    }

    await vanessa.setQuestion(new Question({ text: `Anyway, what did you want to talk about?`, key: `v3VanessaCoffeeMentionedChris` })
        .option({ title: `Confront her about Chris`, key: true })
        .option({ title: `Don't mention Chris`, key: false }));


    if (Question.globalAnswers.v3VanessaCoffeeMentionedChris) {

        mc.talk(`I wanted to talk to you about the other day at the bar.`);
        mc.talk(`But that's not the reason I brought it up.`);
        vanessa.talk(`So?`);
        mc.talk(`I wanted to talk about what happened after I left.`);
        if (Question.globalAnswers.v2BeachTeaseVannesa) {

            ImageClass.setImage(images.v3.VanessaCoffee1_1);
            vanessa.talk(`This again? We've talked about that at the beach already!`);
            vanessa.talk(`We are just friends.`);
            mc.think(`She is obviously not a good liar...`);
        } else {

            vanessa.talk(`What is there to talk about?`);
            vanessa.talk(`When you left, the bar had one less person in it.`);
        }

        mc.talk(`Vanessa... I know everything.`);
        mc.talk(`I know you didn't know the bartender before that night.`);
        mc.talk(`And I know you stayed with him after I left.`);
        mc.talk(`And I know what you did after you were done with your conversation.`);

        ImageClass.setImage(images.v3.VanessaCoffee1_3);
        vanessa.talk(`And what were we doing?`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            mc.talk(`You sucked his cock.`);
            mc.talk(`Do you remember that you let him take a picture of you on his phone?`);
            mc.talk(`I've seen it.`);
            vanessa.talk(`Why the hell were you spying on me in the first place?`);
            mc.think(`Weird response... Does she even care I know?`);
        } else {
            mc.talk(`You tell me.`);
            ImageClass.setImage(images.v3.VanessaCoffee1_4);
            vanessa.talk(`There is nothing to tell.`);
            mc.talk(`He said he has a picture of you.`);
            vanessa.talk(`Have you seen it?`);
            mc.talk(`No, I've not.`);
            vanessa.talk(`Well, he was just taking a photo of me helping him with the dishes.`);
            mc.talk(`Do you expect me to believe it?\nHelping some random bartender with the dishes?`);
            vanessa.talk(`You left without paying and I didn't have money so I had to do something.`);
            mc.think(`I should have looked at the picture...fuck.`);
            mc.think(`I know she is lying, but I can't prove it.`);
            vanessa.talk(`Why the hell were you spying on me in the first place?`);
        }
        mc.talk(`My gut told me to follow you.`);
        vanessa.talk(`If you have a gut problem you should go to a clinic, not to a bar.`);
        mc.talk(`Do you even care I know?`);
        return jump(VanessaCoffee4, "VanessaCoffee4");
    } else {
        mc.talk(`I just wanted to see how you are doing.`);
        vanessa.talk(`I am having the time of my life.`);
        vanessa.talk(`I love serving annoying people for minimum wage.`);
        vanessa.talk(`Anyway, I thought you came to talk about something more interesting.`);
        return jump(VanessaCoffee5ChitChat, "VanessaCoffee5ChitChat");
    }

};

export const VanessaCoffee4 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_3);
    await vanessa.setQuestion(new Question({ text: `Not yet, because I have no idea what you are trying to gain.`, key: `v3VanessaCoffeeWhatTryingToGain` })
        .option({ title: `Don't hurt Joey`, key: "dontHurtJoey" })
        .option({ title: `Blackmail her`, key: "blackmailHer" })
        .option({ title: `Nothing`, key: "nothing" }));


    if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
        mc.talk(`I don't want you to hurt Joey.`);
        vanessa.talk(`I'm not.`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {

            mc.talk(`Do you think it's ok to suck other person's dick behind his back?`);
            vanessa.talk(`Have you seen Joe?! He is happy.\nIsn't that all that matters?`);
            mc.talk(`He wouldn't be if he knew...`);
            vanessa.talk(`But you wouldn't tell him.`);
            mc.talk(`I'm not going to, for now, but you have to stop it.`);
        } else {

            mc.talk(`Do you think it's ok to spend some alone time with random guys?`);
            mc.talk(`Who knows what you did.`);
            vanessa.talk(`I do, I did the dishes.`);
            mc.talk(`Yeah... The dishes.`);
            vanessa.talk(`Anyway, you should stop it.`);
        }
        vanessa.talk(`You are no fun!`);

    } else if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
        await mc.set((properties) => {
            properties.vanessaStatus = "blackmailAttempt";
        });

        return jump(VanessaCoffee5Blackmail, "VanessaCoffee5Blackmail");
    } else {
        mc.talk(`Nothing really.`);
        mc.talk(`I just wanted to talk to you about it and see how you'd react.`);
        vanessa.talk(`Did I pass your little test?`);
        mc.talk(`Not really.`);
    }
    mc.talk(`Aren't you suppose to be a little more defensive?`);
    mc.talk(`I just told you what I know, and you know I can tell it to Joey and ruin everything for you.`);
    mc.talk(`But you just don't give a flying fuck.`);
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {


        vanessa.talk(`I don't think I did something wrong.`);
        vanessa.talk(`There are things you don't know.`);


    } else {

        vanessa.talk(`Give a fuck about what?`);
        vanessa.talk(`That I was spending some time with that guy?`);
        vanessa.talk(`I did nothing...you can tell him.`);
        vanessa.talk(`But before you do...`);
        vanessa.talk(`First, there are things you don't know.`);

    }
    vanessa.talk(`Second, I've learned a lot about you.\nYou won't tell him.`);
    vanessa.talk(`It could ruin your friendship with him.`);
    vanessa.talk(`What do you think he will do if he finds out you were lying to him about going with Ann to the bar.`);
    vanessa.talk(`And right after you lied to him, you went with his girlfriend to see her trying on some clothes.`);
    ImageClass.setImage(images.v3.VanessaCoffee1_3);
    vanessa.talk(`And don't even get me started about yesterday.`);
    if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {

        vanessa.talk(`You asked me to show you my boobs.`);
    } else {

        vanessa.talk(`You asked me to show you my panties.`);
        vanessa.talk(`And now Joe knows I wasn't wearing any.`);
    }
    if (Question.globalAnswers.v2_5WhoWouldYouFuck === "vanessa") {

        vanessa.talk(`You also admitted you want to fuck me.`);
    }
    if (Question.globalAnswers.todGoRoomWith === "ann") {
        // TODO: if changing tod scene - make some adjustments here
        vanessa.talk(`And who knows what could have happened in the living room while you sent Joe and Ann to your room.`);

    }
    ImageClass.setImage(images.v3.VanessaCoffee1_4);
    vanessa.talk(`Don't call me a genius, but it sounds like you are trying to steal his girlfriend.`);
    return jump(VanessaCoffee6, "VanessaCoffee6");
};
export const VanessaCoffee6 = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`VanessaCoffee5Blackmail_Question`)) {

        ImageClass.setImage(images.v3.VanessaCoffee1_4);
    }
    customer.talk(`EXCUSE ME!`);
    ImageClass.setImage(images.v3.VanessaCoffee11);
    mc.talk(`Yes?`);
    customer.talk(`Don't you see me standing here?`);
    customer.talk(`Are you going to order something or talk all day long?`);
    await customer.setQuestion(new Question({ text: `Unlike you, I'm in a hurry, I have places to be.`, key: `v3VanessaCoffeeCustomerApologized` })
        .option({ title: `I'm sorry`, key: true })
        .option({ title: `Get lost`, key: false }));


    if (Question.globalAnswers.v3VanessaCoffeeCustomerApologized) {
        await mc.set((properties) => {
            properties.v3RudeToTheCustomer = false;
        });
        mc.talk(`I'm sorry, I didn't see you.`);
        customer.talk(`Of course, you didn't. You were too busy flirting with the barista.`);
        customer.talk(`Now, if you excuse me I'll place my order.`);

        ImageClass.setImage(images.v3.VanessaCoffee11_2);
        customer.talk(`Finally.`);
        customer.talk(`I would like to have a strong espresso and...`);
        vanessa.talk(`Hey grandpa, can't you see we are in a middle of a conversation?`);
        customer.talk(`Excuse me?`);
        vanessa.talk(`You heard right, I was in the middle of something.`);
        customer.talk(`Does your boss know you are talking to your customers like this?`);
        vanessa.talk(`Are you still here? Go take a walk.`);
        customer.talk(`This is the last time I'm coming here.`);
        ImageClass.setImage(images.v3.VanessaCoffee1_1);
        vanessa.talk(`O-M-G! I can't believe how rude people are.`);
    } else {
        await mc.set((properties) => {
            properties.v3RudeToTheCustomer = true;
        });
        mc.talk(`Don't you see I'm in a middle of something?`);
        mc.talk(`Get lost.`);
        customer.talk(`You are a very rude young man.`);
        mc.talk(`And you, barista, are you going to let him talk to your customer like that?`);
        vanessa.talk(`You didn't order anything yet so you aren't my customer.`);
        customer.talk(`I would if you had better service.`);
        customer.talk(`That's the last time I'm coming here.`);
        ImageClass.setImage(images.v3.VanessaCoffee1_1);
        vanessa.talk(`${mc.name}! You surprise me a bit more every day!`);
        vanessa.talk(`I didn't think you had that fire in you.`);
    }
    vanessa.talk(`Well anyway!`);
    if (Question.globalAnswers.v3VanessaCoffeeMentionedChris) {

        vanessa.talk(`Just keep quiet about that little incident and I'll make it worth your while.`);
        mc.talk(`How?`);
        vanessa.talk(`I don't know how just yet. But I will.`);
        vanessa.talk(`When you need me I'll be there for you!`);
        vanessa.talk(`Do we have a deal?`);
        mc.talk(`Yes.`);
        vanessa.talk(`GREAT!`);
        mc.think(`I must accept her terms after that little monologue of hers.`);
        mc.talk(`I'll get going now.`);
    } else {

        vanessa.talk(`It was really nice talking to you.`);
        // don't need this line given the line below: Stop by anytime...
    }

    vanessa.talk(`Stop by anytime! I'm usually really bored in here.`);
    mc.talk(`Maybe I will.`);
    vanessa.talk(`Bye, ${mc.name}.`);
    return jump(AfterVanessaCoffee, "AfterVanessaCoffee");
};

export const VanessaCoffee5Blackmail = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_1);
    mc.talk(`I want the same treatment you gave Chris or I'll tell Joey all I know.`);
    ImageClass.setImage(images.v3.VanessaCoffee1_4);
    if (!Question.globalAnswers.v2AgreeToSeeBJPic) {
        vanessa.talk(`Same treatment?`);
        vanessa.talk(`Call me when you need help with your dishes and I'll come running.`);
        mc.talk(`I'm serious.`);
        vanessa.talk(`You know, if you want to blackmail someone you need some kind of leverage.`);
        vanessa.talk(`And right now you have nothing.`);
        vanessa.talk(`I don't know what you think I've done, but it's your word against mine.`);
        mc.think(`She is not stupid...`);
        await endReplay();
        return jump(VanessaCoffee6, "VanessaCoffee6");
    }
    vanessa.talk(`Fine.`);
    mc.talk(`Fine? Just like that?`);

    ImageClass.setImage(images.v3.VanessaCoffee1_1);
    vanessa.talk(`You can grab some candles from the backroom if you want this blackmail to be more romantic.`);
    mc.talk(`I was expecting you would try to get me to back off.`);
    vanessa.talk(`What's the point?`);
    vanessa.talk(`If you went this far you already have a plan in mind.`);
    vanessa.talk(`Why should I waste my time?`);
    vanessa.talk(`Drop the pants and come behind the counter.`);
    mc.talk(`Right here and now?`);
    vanessa.talk(`Sure, at least I'll get some money out of this as well.`);
    mc.think(`Something is fishy, she is taking it too well...`);
    ImageClass.setImage(images.v3.VanessaCoffee7);
    vanessa.talk(`I must say, I'm surprised.\nYou have a really nice cock.`);
    vanessa.talk(`Oh, there is one more thing I forgot to say.`);
    vanessa.talk(`You are making a huge mistake.`);
    return jump(VanessaCoffee5Blackmail_Question, "VanessaCoffee5Blackmail_Question");
};

export const VanessaCoffee5Blackmail_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee7);
    await vanessa.setQuestion(new Question({ text: `It's your last chance to back off.`, key: `v3VanessaCoffeeJustSuckIt` })
        .option({ title: `Back off`, key: false })
        .option({ title: `Just suck it`, key: true }));


    if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
        await mc.set((properties) => {
            properties.vanessaStatus = "blackmail";
        });
        mc.talk(`Just suck it.`);
        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeHJ);
        vanessa.talk(`Just like that? No foreplay?`);
        vanessa.talk(`I thought you were a gentleman.`);
        mc.talk(`Do it.`);
        vanessa.talk(`You are the boss.`);
        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeLick);
        mc.think(`She started licking my cock.`);
        mc.think(`Her tongue felt so nice.`);


        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeHJ);
        vanessa.talk(`So, is it worth it?`);
        vanessa.talk(`Blackmailing your best friend's girlfriend.`);
        mc.talk(`So far it is.`);
        mc.think(`I know I'm kinda forcing her to do it, but she seems to like it.`);
        customer.talk(`AHEM AHEM.`);
        mc.think(`What the fuck is that?`);
        ImageClass.setImage(images.v3.VanessaCoffee11);
        customer.talk(`Are you just going stand there or am I going to get some service around here?`);
        ImageClass.setImage(images.v3.VanessaCoffee9);
        mc.think(`He doesn't see Vanessa.`);
        ImageClass.setImage(images.v3.VanessaCoffee8);
        vanessa.talk(`Don't be a jerk give the man some service, haha.`, { method: "Whispering" });

        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeHJ);
        mc.think(`She is really enjoying it.`);
        mc.think(`I can't really move, he'll see I have no pants on.`);
        return jump(VanessaCoffee5Blackmail_Customer_Question, "VanessaCoffee5Blackmail_Customer_Question");
    } else {
        mc.talk(`You are right.`);
        mc.talk(`I don't know what I was thinking.`);
        vanessa.talk(`That's fine. I can't blame you.`);
        vanessa.talk(`It could have been the easiest blowjob of your life.`);
        vanessa.talk(`And trust me, I know how to give head.`);
        mc.talk(`I've made my decision.`);
        ImageClass.setImage(images.v3.VanessaCoffee1_1);
        vanessa.talk(`Are there anymore things you want to get out of the way?`);
        mc.talk(`Not that I can think of right now.`);
        await endReplay();
        // vanessa.talk(`Great, so I'll try to do some actual job so I won't get fired.`);
        // vanessa.talk(`Cya around ${mc.name}.`);
        // mc.talk(`Bye Vanessa.`);
        return jump(VanessaCoffee6, "VanessaCoffee6");
    }

};

export const VanessaCoffee5Blackmail_Customer_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee8);
    await customer.setQuestion(new Question({ text: `Are you going to give me some service or not?`, key: `v3VanessaCoffeeToldCustomerFuckOff` })
        .option({ title: `We are closed`, key: false })
        .option({ title: `Fuck off`, key: true }));

    if (Question.globalAnswers.v3VanessaCoffeeToldCustomerFuckOff) {
        await mc.set((properties) => {
            properties.alpha++;
            properties.v3RudeToTheCustomer = true;
        });

        mc.talk(`Fuck off. I'm busy.`);
        customer.talk(`Excuse me?`);
        mc.talk(`You heard me.`);

        ImageClass.setImage(images.v3.VanessaCoffee14);
        mc.think(`Talking like that got Vanessa really excited.`);
        mc.think(`She put her hands behind her back and her rhythm got faster.`);
        ImageClass.setImage(images.v3.VanessaCoffee11);
        customer.talk(`Your parents failed raising you.`);
        customer.talk(`That's the last time I'm coming here.`);

        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeHJ);
        vanessa.talk(`You showed him! Haha!`);
        vanessa.talk(`I didn't know you had that in you.`);
        ImageClass.setImage(images.v3.Anim_VanessaCoffeeDT.poster);
        vanessa.talk(`You should get a reward for that.`);
        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeDT, { duration: 0, loop: 0 });
        // ImageClass.setImage(images.v3.VanessaCoffee13);
        mc.talk(`Ahhh....`);
        mc.think(`Holy shit, I can feel my cock sliding down her throat.`);
        mc.think(`It feels so good. I regret nothing.`);
        ImageClass.setImage(images.v3.Anim_VanessaCoffeeHJ.poster);
        vanessa.talk(`Well, it was fun.\nYou can leave now.`);
    } else {
        await mc.set((properties) => {
            properties.v3RudeToTheCustomer = false;
        });
        mc.talk(`I'm sorry but we are closed.`);
        customer.talk(`Closed? It's not even noon.`);
        customer.talk(`I demand to get some service.`);
        mc.talk(`Not right now, sir.`);
        customer.talk(`I would like to talk to the manager.`);
        ImageClass.setImage(images.v3.VanessaCoffee9);
        vanessa.talk(`Holy shit grandpa. Fuck off.`);
        customer.talk(`What?\nWho said that? Was that the manager?`);
        ImageClass.setImage(images.v3.VanessaCoffee10);
        vanessa.talk(`Are you having hearing problem?`);
        customer.talk(`What were you doing down there?\nWere you giving him...?`);
        vanessa.talk(`Don't be a pervert.`);
        customer.talk(`So you didn't...?`);
        vanessa.talk(`Of course I did.`);
        vanessa.talk(`Now go away.`);

        customer.talk(`That's the last time I'm coming here!`);

        ImageClass.setAnimation(images.v3.Anim_VanessaCoffeeHJ);
        vanessa.talk(`Finally, some peace and quiet.`);
        vanessa.talk(`Why do people come here anyway?\nWe serve the worst coffee in the city.`);
        mc.talk(`I don't know. Just continue.`);
        ImageClass.setImage(images.v3.Anim_VanessaCoffeeHJ.poster);
        vanessa.talk(`Nah, I think we are good here.`);


    }
    mc.talk(`What? But I didn't cum.`);
    vanessa.talk(`You said nothing about cumming.`);
    mc.talk(`Are you really going to leave me with blue balls?`);
    vanessa.talk(`You asked for a blowjob and you got one.`);
    mc.talk(`I said I wanted the same treatment as Chris.`);
    vanessa.talk(`Did you see a picture of him cumming?`);
    mc.talk(`No...`);
    vanessa.talk(`So that's it!\nYou got the same treatment.`);
    mc.talk(`Holy shit, you're such a tease.`);
    await endReplay(replayScenesList.v3vanCoffeeBJ);
    return jump(VanessaCoffee5Blackmail2, "VanessaCoffee5Blackmail2");
};

export const VanessaCoffee5Blackmail2 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });
    mc.talk(`I can't believe she left me hanging like that... What a bitch.`);
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};
export const VanessaCoffee5ChitChat = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_1);
    if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {

        vanessa.talk(`Like how much you liked seeing my boobs yesterday.`);
    } else {

        vanessa.talk(`Like how much you liked seeing my shaved pussy yesterday.`);
        if (mc.properties.vanessaRelationship > 5) {
            vanessa.talk(`You know, I did it specially for you.`);

            vanessa.talk(`I was hoping your would dare me to lift up my skirt.`);
            if (Question.globalAnswers.v2VanessaClothesRedBlackDress === "removePanties") {
                vanessa.talk(`After that day at my place, when you asked me to remove my panties, I was sure you would like that.`);
                mc.think(`I knew it!`);
            }
        } else {

            mc.talk(`I really liked seeing it.`);
        }
    }


    if (Question.globalAnswers.todWatchedJoeVanessaFucking) {

        vanessa.talk(`And did you like seeing our little show at night?`);
        mc.think(`Holy shit, did she see me?`);
        mc.talk(`What do you mean?`);
        vanessa.talk(`Don't play innocent with me.`);
        vanessa.talk(`I saw you were spying on us last night.`);
        mc.talk(`You weren't exactly hiding.`);
        mc.think(`She saw me and she didn't even try to stop.`);

        return jump(VanessaCoffee5Blackmail2_Question, "VanessaCoffee5Blackmail2_Question");
    }
    return jump(VanessaCoffee6, "VanessaCoffee6");
};
export const VanessaCoffee5Blackmail2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_1);
    await vanessa.setQuestion(new Question({ text: `Did you like watching us?`, key: `v3VanessaCoffeeLikedWatchingVanessaJoeFuck` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.v3VanessaCoffeeLikedWatchingVanessaJoeFuck) {
        mc.talk(`I did.`);
        vanessa.talk(`I didn't know you are a peeping Tom.`);
        vanessa.talk(`I hope it turned you on, I did my best to put on a good show for you.`);
        mc.talk(`Did Joey see me?`);
        vanessa.talk(`No he didn't.`);
        vanessa.talk(`And I didn't tell him, that will be our little secret.`);
    } else {
        mc.talk(`I didn't.`);
        vanessa.talk(`You didn't?\nI tried to put on a good show for you!`);

        return jump(VanessaCoffee5Blackmail2_Question2, "VanessaCoffee5Blackmail2_Question2");
    }
    return jump(VanessaCoffee6, "VanessaCoffee6");
};

export const VanessaCoffee5Blackmail2_Question2 = async (): Promise<any> => {
    ImageClass.setImage(images.v3.VanessaCoffee1_1);
    await vanessa.setQuestion(new Question({ text: `Why didn't you?`, key: `v3VanessaCoffeeWhyDidntLikeWatchVanNJoeFuck` })
        .option({ title: `Because it wasn't me`, key: `IWishItWasMe` })
        .option({ title: `You could have done better`, key: `couldHaveDoneBetter` }));


    if (Question.globalAnswers.v3VanessaCoffeeWhyDidntLikeWatchVanNJoeFuck === "IWishItWasMe") {
        await mc.set((properties) => {
            properties.vanessaRelationship += 10;
        });
        mc.talk(`Because it wasn't me.`);
        vanessa.talk(`Look at you!\nWhat will Joe say?`);
        mc.talk(`Are you going to tell him?`);
        vanessa.talk(`No. Will you?`);
        mc.talk(`No.`);
        vanessa.talk(`Great then.`);
    } else {

        mc.talk(`You could have done better.`);
        vanessa.talk(`I'll try even harder next time.`);
    }

    return jump(VanessaCoffee6, "VanessaCoffee6");
};

export const AfterVanessaCoffee = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomAlone_2, { transition: true });

    mc.think(`I went to see Vanessa with a plan to confront her about Chris.`);
    if (Question.globalAnswers.v3VanessaCoffeeMentionedChris) {
        mc.think(`And I followed it through.`);
        if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
            if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt === false) {
                mc.think(`I tried to blackmail her but decided to back off at the end...`);
                mc.think(`Her hands on my dick felt nice... But it would have been a mistake to follow it through.`);
            } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt === true) {
                mc.think(`I'm not sure that blackmailing her was a good idea.`);
                mc.think(`I didn't even cum... What a tease.`);
            } else {
                mc.think(`I tried to blackmail her, but I didn't have any leverage over her...`);
            }
        } else if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
            if (mc.properties.vanessaRelationship > 3) {
                mc.think(`Even though I like Vanessa, I'm looking out for Joey's best interests.`);

            } else {

                mc.think(`But I'm just looking out for Joey's best interests.`);
            }
        } else {
            mc.think(`I didn't really know what I wanted from her in the end.`);
            mc.think(`And she is not stupid, she can easily convince Joey I'm trying to hit on her.`);
            mc.think(`I'll have to see what she is going to do about this.`);
        }


    } else {
        mc.think(`But at the end I decided to keep my mouth shut and say nothing.`);
        if (mc.properties.annRelationship > 5) {

            mc.think(`The fact that I really like her influenced my judgment for sure.`);
        } else {
            mc.think(`I just might be falling for her, and I don't know why.`);
            mc.think(`I guess I like the bitchy attitude in girls.`);
            mc.think(`And the fact she is Joey's girlfriend makes it even harder for me...`);
        }
    }

    if (Game.seenScenarios.includes(`RoomAfterRecapJoey`)) {

        mc.think(`Anyway, maybe Joey has made it to the gym. I should give him a call.`);
    } else {

        mc.think(`Anyway, I wonder what Joey is doing, I should give him a call.`);
    }


    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};


